module.exports = __webpack_public_path__ + "static/img/btn.a1d90f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteImg/btn.png
// module id = eqG4
// module chunks = 23